export default __webpack_public_path__ + "static/media/019-musician.35d39e42.svg";